<template>
  <v-container style="max-width: 1100px!important;">
    <!-- Alert pro zobrazení zprávy -->
    <v-alert type="error" v-if="errorMessage" @click="clearAlert">{{ errorMessage }}</v-alert>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12" md="6">
    <h2>{{ $t('settings.settings_title') }}:</h2>
      <v-row>
        <v-col cols="6" md="6">
        <v-text-field v-model="user.first_name" :label="$t('general.first_name_label')" :rules="[rules.required, rules.units]" disabled hide-details="true" />
      </v-col>
        <v-col cols="6" md="6">
        <v-text-field v-model="user.last_name" :label="$t('general.last_name_label')" :rules="[rules.required, rules.units]" disabled />
      </v-col>
      </v-row>
      <v-text-field v-model="user.email" label="Email" :rules="[rules.required, rules.email]" required />
      <v-text-field v-model="user.si_number" :label="$t('general.si_number_label')" type="number" :rules="[rules.siNumber]" />
      <v-text-field v-model="user.new_password" :label="$t('settings.new_password_label')" type="password" :rules="[rules.password]" autocomplete="new-password" />
      <v-text-field v-model="confirmPassword" :label="$t('settings.confirm_new_password_label')" type="password" :rules="[() => user.new_password === confirmPassword || $t('rules.password_match')]" v-if="user.new_password" autocomplete="new-password" />
      <v-tooltip location="start center" origin="auto" :text="$t('settings.assist_user_help')">
        <template v-slot:activator="{ props }">
          <v-autocomplete
            v-bind="props"
            v-model="user.assist_user"
            :items="assistUser.filter(u => u.id !== Number(authStore.userID))"
            :label="$t('settings.assist_user_label')"
            item-value="id"
            item-title="fullName"
            :placeholder="$t('settings.assist_user_placeholder')"
            clearable
            multiple
            chips
            closable-chips
            :no-data-text="$t('settings.assist_user_no_data')"
        />
        </template>
      </v-tooltip> 
      <v-select :label="$t('settings.currency_label')" v-model="user.account_currency" :items="CURRENCY_ITEMS"></v-select> 
      <v-tooltip location="start center" origin="auto" :text="$t('settings.email_privacy_help')">
        <template v-slot:activator="{ props }">
          <v-switch v-bind="props" v-model="user.allow_email" color="primary" :label="$t('settings.email_privacy_label')" />
        </template>
      </v-tooltip> 
      <v-row>
        <v-col cols="6" md="3">
        <v-text-field disabled event_type v-model="user.index" :label="$t('general.index_label')" hide-details="true" />
        </v-col>
        <v-col cols="6" md="3">
        <v-text-field disabled event_type v-model="user.birth_year" :label="$t('general.birth_year_label')" type="number" :rules="[rules.year]" hide-details="true" />
        </v-col>
        <v-col cols="6" md="3">
        <v-select disabled v-model="user.gender" :items="genders" :label="$t('general.gender_label')" hide-details="true" />
        </v-col>
        <v-col cols="6" md="3">
        <v-select disabled v-model="user.country" :items="countryOptions" :label="$t('general.country_label')" />
        </v-col>
        <!-- <v-text-field v-model="user.adress" label="Adresa"></v-text-field> -->
      </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <h2>{{ $t('settings.travel_header') }}:</h2>
        <v-text-field
          v-model="user.adress"
          :label="$t('settings.address_label')"
          :placeholder="$t('settings.address_placeholder')"
        />
        <v-text-field v-model="user.car" :label="$t('settings.car_label')" :hint="$t('settings.car_hint')" />
        <v-text-field v-model="user.fuel_consumption" :label="$t('settings.fuel_consumption_label')" type="number" suffix="l/100km" :rules="[rules.fuelConsumption]" />
        <v-radio-group
          v-model="user.fuel_type"
          :label="$t('settings.fuel_type_label')"
          inline
        >
          <v-radio :label="$t('settings.fuel_petrol')" color="green" value="petrol" />
          <v-radio :label="$t('settings.fuel_diesel')" value="diesel" />
        </v-radio-group>

        <h2>{{ $t('settings.calendar_display_header') }}:</h2>
        <v-btn-toggle
          :model-value="authStore.calendarType"
          @update:model-value="val => { if (val) { authStore.toggleCalendar(); snackbar.success(t('messages.updated')) } }"
          mandatory
          density="compact"
          color="primary"
          class="mb-4"
        >
          <v-btn value="table">
            <v-icon start>mdi-calendar-text</v-icon>
            {{ $t('settings.calendar_table') }}
          </v-btn>
          <v-btn value="graphical">
            <v-icon start>mdi-calendar-month</v-icon>
            {{ $t('settings.calendar_graphical') }}
          </v-btn>
        </v-btn-toggle>
        <v-switch
          :model-value="authStore.calendarShowMore"
          @click="() => { authStore.toggleCalendarShowMore(); snackbar.success(t('messages.updated')) }"
          :label="$t('home.auto_show')"
          color="primary"
          hide-details
          class="mb-4"
        />

        <h2>{{ $t('settings.appearance_header') }}:</h2>
        <v-btn-toggle
          :model-value="authStore.theme"
          @update:model-value="onThemeChange"
          mandatory
          density="compact"
          color="primary"
          class="mb-4"
        >
          <v-btn value="system">
            <v-icon start>mdi-theme-light-dark</v-icon>
            {{ $t('settings.theme_system') }}
          </v-btn>
          <v-btn value="light">
            <v-icon start>mdi-white-balance-sunny</v-icon>
            {{ $t('settings.theme_light') }}
          </v-btn>
          <v-btn value="dark">
            <v-icon start>mdi-weather-night</v-icon>
            {{ $t('settings.theme_dark') }}
          </v-btn>
        </v-btn-toggle>

      </v-col>
      </v-row>

      <v-btn color="success" @click="updateUser" :disabled="!valid" style="float:right" class="mb-4">{{ $t('general.save') }}</v-btn>
    </v-form>
  </v-container>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import apiClient from '/api.js';
import { useAuthStore } from '/auth.js';
import { genders } from '@/components/const/gender.js';
import {useSnackbarStore} from '@/stores/snackbarStore'
import { useI18n } from 'vue-i18n'
import { useTheme } from 'vuetify'
import { countryCodeMap } from '@/utils/countryCodes.js'
import { CURRENCY_ITEMS} from '@/components/const/enums.js';


const { t } = useI18n()
const snackbar = useSnackbarStore()
const authStore = useAuthStore();
const theme = useTheme();

const onThemeChange = (val) => {
  if (!val) return;
  authStore.setTheme(val);
  theme.change(val);
  snackbar.success(t('messages.updated'));
};
const errorMessage = ref('');
const user = ref({
  email: '',
  first_name: '',
  last_name: '',
  birth_year: null,
  si_number: '',
  index: '',
  gender: '',
  country: '',
  adress: '',
  car: '',
  fuel_type: 'petrol',
  fuel_consumption: null,
  new_password: '',
  allow_email: false,
});
const confirmPassword = ref('');
const countryOptions = Object.keys(countryCodeMap).sort()

const valid = ref(false);
const rules = {
  required: value => !!value || t('rules.required'),
  units: value => value.length <= 30 || t('rules.max_30'),
  email: value => /.+@.+\..+/.test(value) || t('rules.invalid_email'),
  year: value => !value || (value >= 1900 && value <= new Date().getFullYear()) || t('rules.invalid_year'),
  siNumber: value => !value || /^\d{4,7}$/.test(value) || t('rules.si_range'),
  password: value => !value || value.length >= 8 || t('rules.password_min'),
  fuelConsumption: value => 
    (value === null || (value >= 0 && value <= 30)) || t('rules.fuel_range'),
};


async function fetchUserSettings() {
  try {
    const response = await apiClient.get('account/settings/');
    user.value = response.data;
  } catch (error) {
    console.error('', error);
  }
}

const assistUser = ref([]);

const fetchAssistUser = async () => {
  try {
    const response = await apiClient.get('account/?list=true');
    assistUser.value = response.data; 
  } catch (error) {
    console.error(t('errors.accounts_load_failed'), error);
  }
};



onMounted(async () => {
// Kontrola, zda existuje zpráva k zobrazení po načtení stránky

  const errormessage = localStorage.getItem('errorMessage');
  if (errormessage) {
    errorMessage.value = errormessage;
    localStorage.removeItem('errorMessage');// Odstranění zprávy po jejím zobrazení
  }

  await fetchUserSettings();
  fetchAssistUser();
});

 // Sledování změn pro firstName a uložení do localstore
watch(() => user.value.first_name, newVal => {
  localStorage.setItem('firstName', newVal);
});

 // Sledování změn pro last_name a uložení do localstore
watch(() => user.value.last_name, newVal => {
  localStorage.setItem('last_name', newVal);
});


const updateUser = async () => {
  if (valid.value && (!user.value.new_password || user.value.new_password === confirmPassword.value)) {
    try {
      // Převod prázdného stringu na null
      const updateData = { ...user.value };
      if (updateData.fuel_consumption === "") {
        updateData.fuel_consumption = null;
      }
      await apiClient.put('account/settings/', updateData);
       // Zde zavoláme logout, pokud byla změna hesla úspěšná
      if (user.value.new_password) {
        authStore.logout(); // Zavolání odhlášení
        snackbar.success(t('messages.saved_and_logged_out'));
        errorMessage.value = '';
      } else {
        snackbar.success(t('messages.updated'));
        errorMessage.value = '';
        fetchUserSettings();
      }

    } catch (error) {
    console.error('Chyba při aktualizaci uživatele:', error);
    if (error.response && error.response.status === 409) {
      errorMessage.value = error.response.data.error; // Zobrazení chyby vrácené z API
      window.scrollTo({ top: 0, behavior: 'smooth' }); // Scrollování nahoru pro zobrazení chybové zprávy
      console.error(error);
    } else {
      errorMessage.value = t('errors.update_failed');
      window.scrollTo({ top: 0, behavior: 'smooth' }); // Scrollování nahoru pro zobrazení chybové zprávy
      }
    }
  }
};




</script>

<style scoped>

h2 {
  margin: 10px;
}

</style>